import { useState, type FormEvent } from "react";
import { ApiError } from "../api";
import { useSession } from "../session";

export function LoginPage() {
  const { login } = useSession();
  const [key, setKey] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(key.trim());
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Sign-in failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <form onSubmit={submit} aria-labelledby="login-title">
        <div className="brand">
          <svg className="brand-mark" viewBox="0 0 48 40" role="img" aria-hidden="true">
            <rect x="0" y="0" width="48" height="40" rx="11" fill="#0E1B3A" />
            <path d="M7 24 h7 l4 -11 l6 20 l4 -13 l3 6 h9" fill="none" stroke="#F5A623"
              strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="39" cy="26" r="2.6" fill="#2DA6A0" />
          </svg>
        </div>
        <span className="eyebrow" style={{ display: "block", textAlign: "center" }}>Nasterra</span>
        <h1 id="login-title">SignalFabric</h1>
        <p className="muted" style={{ textAlign: "center" }}>Sign in with an API key. It is exchanged for a session cookie and not stored in the browser.</p>
        <label htmlFor="api-key">API key</label>
        <input
          id="api-key"
          type="password"
          autoComplete="off"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          placeholder="sf_…"
          required
        />
        {error && (
          <p role="alert" className="error">
            {error}
          </p>
        )}
        <button type="submit" className="amber" disabled={busy || !key.trim()}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
